import { Tooltip } from '@material-ui/core';
import CSS from 'csstype';
import React from 'react';

import { IDashboardChartDataKey } from '~/src/dash/api/dashboards/home';
import { IDashboardSubChartMetric } from '~/src/dash/components/charts/common';
import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { IActiveFilters } from '~/src/dash/views/dashboards/DashboardHome/common/common';

const activeStyle = {
  color: publicaColors.black,
  backgroundColor: publicaColors.veryLightGray,
} as CSS.Properties;

const disabledStyle = {
  pointerEvents: 'none',
  opacity: 0.5,
} as CSS.Properties;

interface IDashboardSubchartMetricToggleProps {
  isActive: boolean;
  className?: string;
  isDisabled?: boolean;
  onClick: (metricKey: string, isActive: boolean) => void;
  style?: CSS.Properties;
  label: string;
  itemColor: string;
  metricKey: string;
}

const DashboardSubchartMetricToggle = ({
  isActive = false,
  className = '',
  isDisabled = false,
  onClick,
  style,
  label,
  itemColor,
  metricKey,
}: IDashboardSubchartMetricToggleProps) => {
  return (
    <Tooltip title={isDisabled ? 'Unavailable due to the selected filters.' : ''} placement='top'>
      <div>
        <button
          {...(!isDisabled && { onClick: () => onClick(metricKey, isActive) })}
          className={className}
          style={{
            display: 'inline-block',
            backgroundColor: 'transparent',
            border: `1px solid ${isActive ? publicaColors.mediumGray : publicaColors.lightGray}`,
            borderRadius: '4px',
            lineHeight: 'inherit',
            fontFamily: 'inherit',
            fontStyle: 'inherit',
            whiteSpace: 'nowrap',
            margin: 0,
            minWidth: '40px',
            textAlign: 'center',
            color: publicaColors.darkGray,
            cursor: 'pointer',
            ...(isActive && activeStyle),
            ...(isDisabled && disabledStyle),
            ...style,
          }}
        >
          <Cols gap={spacing.extraSmall} style={{ alignItems: 'center', padding: '2px' }}>
            <Col displayFlex paddingRight='2px'>
              <Text small bold color={itemColor}>
                ❙
              </Text>
            </Col>
            <Col>
              <Text small bold color='inherit'>
                {label}
              </Text>
            </Col>
          </Cols>
        </button>
      </div>
    </Tooltip>
  );
};

interface IDashboardSubchartMetricToggleRowProps {
  orderedMetricKeys: IDashboardChartDataKey[];
  metricsCfg: Record<string, IDashboardSubChartMetric>;
  activeMetrics: IDashboardSubChartMetric[];
  handleChangeActiveMetric: (metricKey: string, isActive: boolean) => void;
  activeFilters: IActiveFilters;
}

export const DashboardSubchartMetricToggleRow = ({
  orderedMetricKeys,
  metricsCfg,
  activeMetrics,
  handleChangeActiveMetric,
  activeFilters,
}: IDashboardSubchartMetricToggleRowProps) => {
  return (
    <Cols
      gap={spacing.small}
      className='hide-scrollbar'
      style={{
        alignItems: 'center',
        overflowX: 'auto',
      }}
    >
      {orderedMetricKeys.map((metricKey) => {
        const metric = metricsCfg[metricKey];
        return (
          <Col key={metricKey}>
            <DashboardSubchartMetricToggle
              isActive={activeMetrics.some((activeMetric) => activeMetric.key === metric.key)}
              isDisabled={metric.isDisabled ? metric.isDisabled(activeFilters) : false}
              label={metric.label}
              itemColor={metric.color}
              metricKey={metric.key}
              onClick={handleChangeActiveMetric}
            />
          </Col>
        );
      })}
    </Cols>
  );
};
